import Skeleton from '@/components/ui/Skeleton'
import StatStripSkeleton from '@/components/ui/StatStripSkeleton'
import CourseCardSkeleton from '@/features/courses/components/CourseCardSkeleton'
import { SHELF_GRID, SHELF_MAX } from '@/screens/courses/components/shelf/shelf-box'

/**
 * The loaded page's shape: the three-cell stat strip, the three-tab strip,
 * the In progress grid (the default tab), and the Pick up next shelf. Light
 * on purpose (the route's pending component ships in the entry chunk,
 * docs/route-loading.md "Pitfalls"): only skeleton primitives and class strings.
 *
 * A guess either way at how many courses a member holds, so held to a single
 * row of four, never a data-dependent count.
 */
export default function MyLearningSkeleton() {
  return (
    <div aria-hidden="true" className="flex flex-col gap-8">
      <StatStripSkeleton cells={3} surface="panel" sub />

      <div className="flex h-11 items-center gap-5 lg:h-9">
        <Skeleton className="h-4 w-24 rounded-xs" />
        <Skeleton className="h-4 w-20 rounded-xs" />
        <Skeleton className="h-4 w-20 rounded-xs" />
      </div>

      <div className={SHELF_GRID}>
        {Array.from({ length: SHELF_MAX }, (_, index) => (
          <CourseCardSkeleton key={index} />
        ))}
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex min-h-9 items-center">
          <Skeleton className="h-5 w-28 rounded-xs" />
        </div>
        <div className={SHELF_GRID}>
          {Array.from({ length: SHELF_MAX }, (_, index) => (
            <CourseCardSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  )
}
